import { render, staticRenderFns } from "./GrandFlooring.vue?vue&type=template&id=55b33a22&scoped=true&"
import script from "./GrandFlooring.vue?vue&type=script&lang=js&"
export * from "./GrandFlooring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b33a22",
  null
  
)

export default component.exports